import moment, {Moment} from 'moment'
import {formatDateLocal} from '../../../formatters/formatMoment'

export class AssocTerm {
    assocTermId: number
    assocTermName: string
    assocTermStartDate: Moment
    assocTermEndDate: Moment
    version: number

    constructor(params: {
        assocTermId: number,
        assocTermName: string,
        assocTermStartDate: Moment,
        assocTermEndDate: Moment,
        version: number,
    }) {
        this.assocTermId = params.assocTermId
        this.assocTermName = params.assocTermName
        this.assocTermStartDate = params.assocTermStartDate
        this.assocTermEndDate = params.assocTermEndDate
        this.version = params.version
    }

    static from(json: any): AssocTerm {
        return new AssocTerm({
            assocTermId: json.assocTermId,
            assocTermName: json.assocTermName,
            assocTermStartDate: moment(json.assocTermStartDate),
            assocTermEndDate: moment(json.assocTermEndDate),
            version: Number(json.version),
        })
    }

    toObject(): object {
        return {
            assocTermId: this.assocTermId,
            assocTermName: this.assocTermName,
            assocTermStartDate: formatDateLocal(this.assocTermStartDate),
            assocTermEndDate: formatDateLocal(this.assocTermEndDate),
            version: this.version,
        }
    }
}
